import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight } from 'lucide-react';
const activities = [{
  title: 'Libros Digitales',
  desc: 'Catálogo curado de eBooks prácticos y accesibles, distribuidos globalmente.'
}, {
  title: 'Funnels Low Ticket',
  desc: 'Especialistas en el diseño y armado de embudos de venta optimizados para conversión.'
}, {
  title: 'Meta Ads',
  desc: 'Campañas publicitarias estratégicas en Facebook e Instagram para escalar el alcance.'
}, {
  title: 'Distribución 100% Online',
  desc: 'Operación digital de punta a punta, sin venta física ni intermediarios.'
}];
export function Activities() {
  return <section id="actividades" className="py-32 md:py-48 px-6 md:px-12 bg-navy-light border-y border-steel" data-id="element-10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24" data-id="element-11">
        <div className="lg:col-span-4" data-id="element-12">
          <FadeIn data-id="element-13">
            <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-muted mb-6 block" data-id="element-14">
              03 — Actividades
            </span>
            <h2 className="font-display text-4xl md:text-5xl text-cream leading-[1.05]" data-id="element-15">
              Áreas de <br className="hidden lg:block" data-id="element-16" />
              Actividad
            </h2>
          </FadeIn>
        </div>

        <div className="lg:col-span-8" data-id="element-17">
          <div className="flex flex-col" data-id="element-18">
            {activities.map((activity, index) => <FadeIn key={activity.title} delay={index * 0.1} data-id="element-19">
                <div className="group flex flex-col md:flex-row md:items-center justify-between py-8 border-b border-steel/50 hover:border-gold transition-colors duration-500 cursor-default" data-id="element-20">
                  <div className="md:w-1/2 mb-4 md:mb-0" data-id="element-21">
                    <h3 className="font-display text-2xl text-cream group-hover:text-gold transition-colors duration-500" data-id="element-22">
                      {activity.title}
                    </h3>
                  </div>
                  <div className="md:w-1/2 flex items-center justify-between" data-id="element-23">
                    <p className="text-muted font-light text-sm md:text-base pr-8" data-id="element-24">
                      {activity.desc}
                    </p>
                    <ArrowRight className="w-5 h-5 text-steel group-hover:text-gold transform group-hover:translate-x-2 transition-all duration-500 flex-shrink-0" data-id="element-25" />
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}